import * as React from 'react';
export function useTimer(interval, callback) {
    React.useEffect(function () {
        var id = setInterval(callback, interval);
        return function () { return clearInterval(id); };
    }, [interval, callback]);
}
